import { axiosInstance } from './axios';
import { IAnnotation } from 'dto/IAnnotation';
import { IComment } from 'dto/IComment';
import { IError } from 'dto/IError';
import useCustomMutation from 'hooks/useCustomMutation';
import useCustomQuery from 'hooks/useCustomQuery';

const queryKeys = {
  get: (documentId: string) => ['annotationService.get', documentId],
};

const get = async (documentId: string): Promise<IAnnotation[]> => {
  const response = await axiosInstance.get(
    `/Annotations?documentId=${documentId}`
  );

  return response.data ?? [];
};

const useGet = (documentId: string) => {
  return useCustomQuery(queryKeys.get(documentId), () => get(documentId));
};

const create = (payload: {
  PageNumber: number;
  Type: string;
  Json: string;
  DocumentId: string;
}): Promise<{data: IAnnotation}> => {
  return axiosInstance.post('/annotation', payload);
};

const useCreate = () => {
  return useCustomMutation(create);
};

const createComment = (payload: { AnnotationId: string; Text: string }): Promise<{ data: IComment }> => {
  return axiosInstance.post('/comment', payload);
};

const useCreateComment = () => {
  return useCustomMutation(createComment);
};

const updateComment = (payload: { CommentId: string; Text: string }): Promise<{ data: IComment }>  => {
  return axiosInstance.put('/comment', payload);
};

const useUpdateComment = () => {
  return useCustomMutation(updateComment);
};

const deleteAnnotation = (payload: { AnnotationId: string }): Promise<{data: IError}> => {
  return axiosInstance.delete('/annotation', {
    data: payload,
  });
};

const useDeleteAnnotation = () => {
  return useCustomMutation(deleteAnnotation);
};

export default {
  useGet,
  useCreate,
  useCreateComment,
  useUpdateComment,
  useDeleteAnnotation,
};
